import {Jurisdiction} from '../../countries/constants'
import {Currency} from '../../currency'
import {BasePrice, Fee} from '../index'

export type TmOwnershipTransferCountryPrice = {
  legalFee?: Fee
  serviceFee: Fee
  total: BasePrice
}

export type TmOwnershipTransferJurisdictionFees = {
  jurisdiction: Jurisdiction
  serviceFee: Fee
  legalFee?: Fee
  total: BasePrice
}

export type TmOwnershipTransferJurisdictionsPrice = {
  jurisdictions: TmOwnershipTransferJurisdictionFees[]
  serviceFeeTotal: BasePrice
  legalFeeTotal: BasePrice
  total: BasePrice
}

export enum AssignmentAgreementServiceType {
  review = 'TM-assignment-review',
  drafting = 'TM-assignment-drafting',
}

export type TmOwnershipTransferTrademarkPrice = {
  jurisdiction: Jurisdiction
  trademarkNumber: string
  serviceFee: Fee
  legalFee?: Fee
}

// Billing view: one line per jurisdiction, priced cumulatively straight from the
// catalog product. The per-trademark breakdown is a display aid for the form
// summary — its marginal amounts telescope to exactly these totals — while these
// are what quote items and invoice lines are built from.
export type TmOwnershipTransferJurisdictionOrderPrice = {
  jurisdiction: Jurisdiction
  numberOfTrademarks: number
  trademarkNumbers: string[]
  serviceFee: Fee
  legalFee?: Fee
}

export type TmOwnershipTransferOrderPrice = {
  trademarkPrices: TmOwnershipTransferTrademarkPrice[]
  jurisdictionPrices: TmOwnershipTransferJurisdictionOrderPrice[]
  assignmentAgreementFee?: Fee
  total: BasePrice
  currency: Currency
  vatIncluded: boolean
  reverseVatCharge: boolean
  vatRate: number
}
